import { Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { KeyboardEvent } from 'react'

interface AnnouncementSearchBarProps {
  searchInput: string
  onSearchInputChange: (v: string) => void
  onSubmit: () => void
}

export function AnnouncementSearchBar({
  searchInput,
  onSearchInputChange,
  onSubmit,
}: AnnouncementSearchBarProps) {
  const { t } = useTranslation('announcements')

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onSubmit()
    }
  }

  return (
    <div className="flex items-center justify-between gap-3 w-full lg:w-80 h-12 px-4 rounded-[10px] border border-[#dadada] bg-white">
      <input
        type="text"
        value={searchInput}
        onChange={(e) => onSearchInputChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t('search.placeholder')}
        aria-label={t('search.placeholder')}
        className="flex-1 min-w-0 h-full bg-transparent text-base tracking-[-0.6px] text-[#131313] placeholder:text-[#a0a0a0] focus:outline-none"
      />
      <button
        type="button"
        onClick={onSubmit}
        aria-label={t('search.submit')}
        className="shrink-0 inline-flex items-center justify-center size-6 text-[#494949] hover:text-[#131313]"
      >
        <Search className="size-6" aria-hidden />
      </button>
    </div>
  )
}
